import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import type { DonationBatchPanel } from '../hooks/useDonationBatchFilters';
import { useConfirmDonationBatch } from '../hooks/useMpP2Mutations';
import type { DonationBatch } from '../types/marketPromotionP2.types';
import { getBatchNumber } from '../utils/batchNumber';
import { DisburseDonationBatchDialog } from './DisburseDonationBatchDialog';

interface BatchDialogProps {
  batch: DonationBatch;
  onClose: () => void;
}

function ConfirmDonationBatchDialog({ batch, onClose }: BatchDialogProps) {
  const confirm = useConfirmDonationBatch(onClose);
  return (
    <ConfirmDialog
      open
      onOpenChange={(open) => !open && onClose()}
      title="Confirm this batch?"
      description={`Batch #${String(getBatchNumber(batch))} moves on to Accounts.`}
      confirmLabel="Confirm"
      isPending={confirm.isPending}
      onConfirm={() => confirm.mutate({ batchId: batch.batchId, isConfirm: true })}
    />
  );
}

interface DonationBatchActionDialogProps {
  panel: DonationBatchPanel;
  batch: DonationBatch | null;
  onClose: () => void;
}

export function DonationBatchActionDialog({
  panel,
  batch,
  onClose,
}: DonationBatchActionDialogProps) {
  if (batch === null) return null;
  if (panel === 'publish') return <ConfirmDonationBatchDialog batch={batch} onClose={onClose} />;
  return <DisburseDonationBatchDialog batch={batch} onClose={onClose} />;
}
